import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingState } from '../../../loading/loading.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AttendanceService } from '../../../../services/attendance.service';
import { DocumentViewModalComponent } from '../../../../components/document-view-modal/document-view-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import * as Globals from '../../../../globals';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { SettingService } from '../../../../services/setting.service';
import { LocalService } from '../../../../services/local.service';

@Component({
  selector: 'app-special',
  templateUrl: './special.component.html',
  styleUrls: ['./special.component.scss']
})
export class SpecialComponent implements OnInit {

  dialogRef: MatDialogRef<ConfirmDialogComponent>;
  loading: LoadingState = LoadingState.NotReady;
  form: FormGroup;
  @Output() getGraceDetailsFromChild = new EventEmitter<string>();
  @Input() leaveDetail;

  defaultPagination: number;
  totalLeavesList: number;
  sort_by = '';
  sort_type = '';
  itemNo: number;
  lower_count: number;
  upper_count: number;
  paginationMaxSize: number;
  itemPerPage: number;
  pageSize: number;
  leavesList: any = [];
  daysDiff:number
  leaveStartDate: string;
  leaveEndDate: string;
  dateRange: any = null;
  errorMsg = ''
  leaveType:any
  showType:boolean = false;
  selectedDocument:boolean = false

  public today: Date = new Date();
  public currentYear: number = this.today.getFullYear();
  public currentMonth: number = this.today.getMonth();
  public currentDay: number = this.today.getDate();
  public minDate: Object = new Date(this.currentYear, this.currentMonth, this.currentDay);
  //public maxDate: Object =  new Date(this.currentYear, this.currentMonth+1, 20);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private attendanceService: AttendanceService,
    private formBuilder: FormBuilder,
    private settingService: SettingService,
    private localService: LocalService,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      date_range: [null, Validators.required],
      leave_type: [null, Validators.required],
      reason: [null, Validators.required],
      document: [null],
      file: null,
    });
    // console.log(this.leaveDetail)

    this.itemNo = 0;
    this.defaultPagination = 1;
    this.paginationMaxSize = Globals.paginationMaxSize;
    this.itemPerPage = Globals.itemPerPage;
    this.pageSize = Globals.pageSize;

    this.getLeaveHistoryList()
  }

  getLeaveHistoryList() {
    var userId = this.localService.getJsonValue('userid');
    let params: URLSearchParams = new URLSearchParams();
    params.set('emp_id', userId.toString());
    params.set('page', this.defaultPagination.toString());   
    if (this.itemPerPage) {
      params.set('page_count', this.itemPerPage.toString());
    }
    this.loading = LoadingState.Processing;
    this.attendanceService.getSpecialLeaveHistoryList(params).subscribe(
      (res: any) => {
        this.leavesList = res['results'];
        this.totalLeavesList = res.count;
        this.itemNo = (this.defaultPagination - 1) * this.itemPerPage;
        this.lower_count = this.itemNo + 1;
        if (this.totalLeavesList > this.itemPerPage * this.defaultPagination) {
          this.upper_count = this.itemPerPage * this.defaultPagination
        }
        else {
          this.upper_count = this.totalLeavesList
        }

        this.loading = LoadingState.Ready;
      },
      err => {
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
        });
      }
    )
  }

  save() {
    if (this.form.valid) {
      if(this.daysValidation()){
      this.loading = LoadingState.Processing;
      const data: any = new FormData();
      data.append("employee ", this.localService.getJsonValue('userid'));
      data.append("leave_type ", this.form.value.leave_type);
      data.append("start_date ", this.leaveStartDate);
      data.append("end_date ", this.leaveEndDate);
      data.append("reason ", this.form.value.reason);
      if(this.form.value.document != null && this.form.value.document != undefined){
        data.append("document ", this.form.value.document);
      }
      this.attendanceService.applySpecialLeave(data).subscribe(
        res => {
          // console.log(res)
          this.getLeaveHistoryList();
          this.form.reset();
          this.dateTimeReset()
          this.getGraceDetailsFromChild.next();
          this.loading = LoadingState.Ready;
          this.toastr.success('Your Leave Appliaction has been Submitted', '', {
            timeOut: 3000,
          });

        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready;
          if (error.error.error.msg) {
            this.toastr.error(error.error.error.msg, '', {
              timeOut: 3000,
            });
          }
          else {
            this.toastr.error('Something went wrong', '', {
              timeOut: 3000,
            });
          }
        }
      )
      }

    } else {
      this.markFormGroupTouched(this.form)
    }
  }

  daysValidation(){
    if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
      var Difference_In_Time = new Date(this.dateRange[1]).getTime() - new Date(this.dateRange[0]).getTime();
      this.daysDiff = Difference_In_Time / (1000 * 3600 * 24) + 1;
      

    }
    //console.log(this.daysDiff)
    if(this.leaveType == 'ML'){
      if(this.daysDiff > 80){
        this.toastr.error('Maternity leave not allowed more than 80 days', '', {
          timeOut: 3000,
        });
        return false;
        // this.dateRange = null;
        // this.leaveType= null
        // this.showType= false
        // this.errorMsg = "Maternity leave not allowed more than 80 days";
        
      }else{
        // this.errorMsg = ''
        return true;
      }
    }
    if(this.leaveType == 'BL'){
      if(this.daysDiff > 7){
        this.toastr.error('Bereavement leave not allowed more than 7 days', '', {
          timeOut: 3000,
        });
        return false;
      }else{
        // this.errorMsg = ''
        return true
      }
    }
    if(this.leaveType == 'CVL'){
      return true
    }
  }

  selectFile(event) {
   // console.log(event.target.files[0].type)
    if (event.target.files[0].type == "image/png" || event.target.files[0].type == "image/jpeg"
      || event.target.files[0].type == "image/jpg"
      || event.target.files[0].type == "application/pdf"
    ) {
      if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          var reader = new FileReader();
          reader.onload = (event) => {

          }
          this.form.patchValue({
            document: event.target.files[0]
          })
          reader.readAsDataURL(event.target.files[i]);
   
          this.selectedDocument = true;
        }


      }
    } else {
      this.toastr.error('Image or PDF file type allowed', '', {
        timeOut: 3000,
      });
    }

  }

  viewDoc(url:string){
    window.open(url,'','height=700,width=800,scrollbars=yes');
   }

  pagination() {
    this.loading = LoadingState.Processing;
    this.getLeaveHistoryList();
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

  dateTimeReset() {
    this.dateRange = null;
    this.leaveStartDate = ''
    this.leaveEndDate = ''
    this.showType = false;
    this.leaveType= null
    this.selectedDocument = false
  }

  formatHandler(event) {
    if (event.value[0] && event.value[1]) {
      let currentDate = new Date();
      let timeFormat = currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds()

      this.leaveStartDate = this.settingService.formatDate(event.value[0]) + " " + timeFormat
      this.leaveEndDate = this.settingService.formatDate(event.value[1]) + " " + timeFormat
      this.showType = true
      this.errorMsg = '';
    }else{
      this.showType = false
    }

    //console.log(this.leaveType)
    //console.log(this.daysDiff)
  
  }

}
